export const TICKETSTATE = {
    COBRADO : 'cobrado',
    CANCELADO : 'cancelado',
    FACTURADO : 'facturado'
}